"use client";

import Link from "next/link";

import { Locale } from "@/i18n";

interface Props {
  lang: Locale;
  href: string;
  target?: "_blank" | "_parent" | "_self" | "_top" | "";
  children: React.ReactNode;
  className?: string;
  prefetch?: boolean;
  onClick?: () => void;
}

function buildUrl(lang: Locale, href: string) {
  if (href.startsWith("http")) {
    return href;
  }
  if (href.startsWith("/")) {
    const relativePath = href.slice(1);
    return `/${lang}/${relativePath}`;
  }
  return href;
}
export function LocalizedLink(props: Props) {
  const {
    lang,
    href,
    children,
    target,
    prefetch = true,
    onClick = () => {
      return;
    },
  } = props;
  const url = buildUrl(lang, href);
  return (
    <Link
      {...props}
      href={url}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : ""}
      prefetch={prefetch}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}
